'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteHeader = twentyninetimes.siteHeader || function () {

    var doc = document.documentElement;
    var body = document.body;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById('js-site-header'),
        header_height = header.clientHeight;

    function init() {
        if ( header ) {
           toggleHeader(header);
        }
    }

    function checkScroll() {
      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;

      ( curScroll > header_height ) 
        ? body.classList.add('scrolled')
        : body.classList.remove('scrolled');

      if (curScroll > prevScroll) { 
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    }

    function toggleHeader(direction, curScroll) {
        
      if (direction === 2 && curScroll > header_height) { 

        body.classList.add('header-hidden');
        prevDirection = direction;
      }
      else if (direction === 1) {
        body.classList.remove('header-hidden');
        prevDirection = direction;
      }
    };

    function checkLogoPlacement() {
      var logo = document.querySelector('#js-site-header .site-logo');
      var logoWhiteElements = document.querySelectorAll('.wp-block-group.has-blue-dark-background-color, .wp-block-group.has-mint-dark-background-color, .logo-white, .logo-hide');
  
      if (logo) {
          var logoRect = logo.getBoundingClientRect();
          var isOverLogoWhite = false;
          var isOverLogoHide = false;
  
          logoWhiteElements.forEach(function(element) {
              var elementRect = element.getBoundingClientRect();
  
              var logoCenterY = logoRect.top + (logoRect.height / 2);
              var logoCenterX = logoRect.left + (logoRect.width / 2);
  
              if (
                  logoCenterY >= elementRect.top &&
                  logoCenterY <= elementRect.bottom &&
                  logoCenterX >= elementRect.left &&
                  logoCenterX <= elementRect.right
              ) {
                  isOverLogoWhite = true;

                  if ( element.classList.contains('logo-hide') ) {
                    isOverLogoHide = true;
                  }
              }
          });
  
          (isOverLogoWhite && !isOverLogoHide) 
            ? logo.classList.add('site-logo--white')
            : logo.classList.remove('site-logo--white');

          (isOverLogoHide) 
            ? logo.classList.add('site-logo--hide')
            : logo.classList.remove('site-logo--hide');

      } else {
          console.log('Logo not found in the header');
      }
    }

    return {
        init : init,
        checkScroll : checkScroll,
        checkLogoPlacement : checkLogoPlacement
    };

}();